import { BaseURL } from '../../../config';

export const COMMON = 'app/Init/COMMON';
export const SUBMIT_EVENT = 'app/Init/SUBMIT_EVENT';
export const ADD_TO_CART = 'app/Init/ADD_TO_CART';
export const ADD_TO_CART_SUCCESS = 'app/Init/ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_ERROR = 'app/Init/ADD_TO_CART_ERROR';

export const ADD_PRIMARY_TO_CART_SUCCESS =
  'app/Init/ADD_PRIMARY_TO_CART_SUCCESS';

export const BALANCE_PRODUCT_ADDTIONS = 'app/Init/BALANCE_PRODUCT_ADDTIONS';

export const REMOVE_FROM_CART = 'app/HomePage/REMOVE_FROM_CART';
export const REMOVE_FROM_CART_SUCCESS = 'app/HomePage/REMOVE_FROM_CART_SUCCESS';
export const REMOVE_FROM_CART_ERROR = 'app/HomePage/REMOVE_FROM_CART_ERROR';

export const REMOVE_FROM_STATE = 'app/HomePage/REMOVE_FROM_STATE';
export const ADD_VARIANT_IDS_OF_PRODUCTS_TO_HIDE =
  'app/Init/ADD_VARIANT_IDS_OF_PRODUCTS_TO_HIDE';

export const SET_ATC_STATUS_ADDING = 'app/Init/SET_ATC_STATUS_ADDING';
export const SET_ATC_STATUS_ADDED = 'app/Init/SET_ATC_STATUS_ADDED';
export const RESET_ATC_STATUS = 'app/Init/RESET_ATC_STATUS';

export const ADDED_ATC_STATUS_HIDE_DELAY = 2000;

// endpoints
export const SEND_EVENT_API = `${BaseURL}/app/event`;
export const ADD_TO_CART_API = `/cart/add.js?mr=1`;
export const ADD_TO_CART_EVENTAPI = `${BaseURL}/app/productadd?mr=1&mrs=1`;
export const REMOVE_FROM_CART_API = `/cart/change.js?mr=1`;
export const FETCH_CART_API = `/cart.js?mr=1`;
